<div class="layout-wrapper bg-white">
  <div class="layout-container d-flex">
    <app-side-nav></app-side-nav>

    <div class="container-fluid mt-2">
      <!-- Heading Row -->
      <div class="row align-items-center mb-4 g-3">
        <div class="col-12 col-md-5 text-lg-start text-center">
          <h4 class="study-heading">
            <span class="text-muted fw-light">Study Management /</span> Site
            List
          </h4>
        </div>

        <div class="col-12 col-md-7 text-lg-end text-center ms-md-auto text-md-end">
          <button
            type="button"
            class="btn custom-button"
            (click)="openAddLocationModal()"
          >
            Add Location
          </button>
        </div>
      </div>

      <!-- Filter Row -->
      <div class="row gy-3 filter-row align-items-center">
        <div class="col-md-2 col-sm-6">
          <input
            type="text"
            class="form-control"
            placeholder="Search by Address"
            [(ngModel)]="searchSiteLocation"
          />
        </div>

        <div class="col-md-2 col-sm-6">
          <select class="form-select cursor-pointer" [(ngModel)]="city">
            <option value="">Search by City</option>
            <option *ngFor="let c of cities" [value]="c">{{ c }}</option>
          </select>
        </div>

        <div class="col-md-3 col-sm-6">
          <select class="form-select cursor-pointer" [(ngModel)]="state">
            <option value="">Search by State</option>
            <option *ngFor="let s of states" [value]="s">{{ s }}</option>
          </select>
        </div>

        <div class="col-md-3 col-sm-6">
          <select class="form-select cursor-pointer" [(ngModel)]="country">
            <option value="">Search by Country</option>
            <option *ngFor="let c of countries" [value]="c">{{ c }}</option>
          </select>
        </div>

        <!-- Buttons -->
        <div class="col-12 col-md-2 d-flex justify-content-center gap-2">
          <button class="btn custom-button px-3" (click)="searchSites()">
            Search
          </button>
          <button class="btn custom-button px-3" (click)="clear()">
            Clear
          </button>
        </div>
      </div>

      <!-- Loader -->
      <div
        *ngIf="loading"
        class="d-flex justify-content-center align-items-center loader-container"
      >
        <div class="spinner-border text-purple"></div>
      </div>

      <!-- Table -->
      <div class="card mt-3" *ngIf="!loading">
        <div class="table-responsive rounded">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Site Name</th>
                <th>Site Address</th>
                <th>City, Country</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let site of sites">
                <td>
                  {{ site.site_name || '-' }}
                  <span *ngIf="site.is_frozen" class="badge bg-info ms-2">❄️ Frozen</span>
                  <span *ngIf="site.is_locked" class="badge bg-warning ms-2">🔒 Locked</span>
                </td>
                <td class="scrollable-cell">{{ site.site_address }}</td>
                <td>{{ site.city }}, {{ site.country }}</td>

                <td>
                  <div class="dropdown">
                    <button class="btn p-0 dropdown-toggle" data-bs-toggle="dropdown">
                      <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end custom-dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item cursor-pointer"
                          (click)="openEditModal(site)"
                          *ngIf="!site.is_frozen && !site.is_locked"
                        >
                          <i class="bx bx-edit-alt me-1"></i>Edit
                        </a>
                      </li>
                      <li>
                        <a
                          class="dropdown-item cursor-pointer"
                          (click)="deleteSite(site.site_id)"
                          *ngIf="!site.is_frozen && !site.is_locked"
                        >
                          <i class="bx bx-trash me-1"></i>Delete
                        </a>
                      </li>
                      <li *ngIf="canManageFreezeLock()">
                        <a
                          *ngIf="!site.is_locked"
                          class="dropdown-item cursor-pointer"
                          (click)="freezeSite(site)"
                        >
                          <i class="bx bx-lock-open me-1" *ngIf="!site.is_frozen"></i>
                          <i class="bx bx-lock me-1" *ngIf="site.is_frozen"></i>
                          {{ site.is_frozen ? 'Unfreeze' : 'Freeze' }}
                        </a>
                      </li>
                      <li *ngIf="canManageFreezeLock()">
                        <a
                          *ngIf="!site.is_locked"
                          class="dropdown-item cursor-pointer"
                          (click)="lockSite(site)"
                        >
                          <i class="bx bx-lock me-1"></i>Lock
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="row mt-4">
        <div class="col d-flex justify-content-center">
          <ul class="pagination mb-0 cursor-pointer">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="prevPage()">Previous</a>
            </li>

            <li
              class="page-item"
              *ngFor="let page of pageRange"
              [class.active]="page === currentPage"
            >
              <a class="page-link mx-2" (click)="goToPage(page)">{{ page }}</a>
            </li>

            <li class="page-item" [class.disabled]="currentPage === pages">
              <a class="page-link" (click)="nextPage()">Next</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Modal -->
<div class="modal fade" id="addLocationModal" tabindex="-1">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-body">
        <app-add-location
          [existingSites]="allSites"
          (locationAddedEvent)="onLocationAdded()"
          (closeFormEvent)="onLocationAdded()"
        ></app-add-location>
      </div>
    </div>
  </div>
</div>

<!-- Edit Modal -->
<div class="modal fade" id="editModal" tabindex="-1">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Site</h5>
      </div>

      <div class="modal-body">
        <div class="mb-3 px-2">
          <label class="form-label">Site Name</label>
          <input
            type="text"
            class="form-control"
            name="site_name"
            [(ngModel)]="selectedSite.site_name"
          />
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn custom-button btn-cancel" data-bs-dismiss="modal">
          Cancel
        </button>
        <button class="btn custom-button" (click)="updateSite()">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Freeze/Unfreeze Site Modal -->
<div
  class="modal fade"
  id="freezeSiteModal"
  tabindex="-1"
  aria-labelledby="freezeSiteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">
        {{ isFreezing ? 'Freeze Site' : 'Unfreeze Site' }}
      </h5>
      <div class="mb-3">
        <p class="text-muted">
          <strong>Site:</strong> {{ currentSite?.site_name }}
        </p>
        <div class="alert alert-info" *ngIf="isFreezing">
          <small>
            Freezing this site will make it view-only. No changes or edits will be allowed until it is unfrozen.
          </small>
        </div>
        <div class="alert alert-success" *ngIf="!isFreezing">
          <small>
            Unfreezing this site will restore all editing capabilities.
          </small>
        </div>
      </div>

      <div class="mb-3">
        <label for="freezeSiteEmail" class="form-label">Email:</label>
        <input
          type="email"
          class="form-control"
          id="freezeSiteEmail"
          [(ngModel)]="freezeEmail"
          placeholder="Enter your email"
          (keyup.enter)="authenticateAndFreezeSite()"
        />
      </div>

      <div class="mb-3">
        <label for="freezeSitePassword" class="form-label">Password:</label>
        <div class="input-group">
          <input
            [type]="showFreezePassword ? 'text' : 'password'"
            class="form-control"
            id="freezeSitePassword"
            [(ngModel)]="freezePassword"
            placeholder="Enter your password"
            (keyup.enter)="authenticateAndFreezeSite()"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="toggleFreezePasswordVisibility()"
          >
            <i class="bx" [class.bx-show]="!showFreezePassword" [class.bx-hide]="showFreezePassword"></i>
          </button>
        </div>
      </div>

      <div class="mb-3">
        <label for="freezeSiteReason" class="form-label">Reason:</label>
        <textarea
          class="form-control"
          id="freezeSiteReason"
          [(ngModel)]="freezeReason"
          rows="3"
          placeholder="Enter reason for {{ isFreezing ? 'freezing' : 'unfreezing' }} this site"
        ></textarea>
      </div>

      <div *ngIf="freezeError" class="text-danger mb-3">
        {{ freezeError }}
      </div>

      <div class="d-flex justify-content-end">
        <button class="btn custom-button me-2" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="authenticateAndFreezeSite()"
          [disabled]="!freezeEmail || !freezePassword || !freezeReason"
        >
          {{ isFreezing ? 'Freeze' : 'Unfreeze' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Lock Site Modal -->
<div
  class="modal fade"
  id="lockSiteModal"
  tabindex="-1"
  aria-labelledby="lockSiteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">Lock Site</h5>
      <div class="mb-3">
        <p class="text-muted">
          <strong>Site:</strong> {{ currentSite?.site_name }}
        </p>
        <div class="alert alert-danger">
          <h6><strong>Warning:</strong></h6>
          <ul class="mb-0">
            <li>Once locked, this site <strong>CANNOT be unlocked.</strong></li>
            <li>You will <strong>NOT be able to make any changes</strong> to this site.</li>
            <li>This action is <strong>IRREVERSIBLE.</strong></li>
          </ul>
        </div>
      </div>

      <div class="mb-3">
        <label for="lockSiteEmail" class="form-label">Email:</label>
        <input
          type="email"
          class="form-control"
          id="lockSiteEmail"
          [(ngModel)]="lockEmail"
          placeholder="Enter your email"
          (keyup.enter)="authenticateAndLockSite()"
        />
      </div>

      <div class="mb-3">
        <label for="lockSitePassword" class="form-label">Password:</label>
        <div class="input-group">
          <input
            [type]="showLockPassword ? 'text' : 'password'"
            class="form-control"
            id="lockSitePassword"
            [(ngModel)]="lockPassword"
            placeholder="Enter your password"
            (keyup.enter)="authenticateAndLockSite()"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="toggleLockPasswordVisibility()"
          >
            <i class="bx" [class.bx-show]="!showLockPassword" [class.bx-hide]="showLockPassword"></i>
          </button>
        </div>
      </div>

      <div class="mb-3">
        <label for="lockSiteReason" class="form-label">Reason:</label>
        <textarea
          class="form-control"
          id="lockSiteReason"
          [(ngModel)]="lockReason"
          rows="3"
          placeholder="Enter reason for locking this site"
        ></textarea>
      </div>

      <div *ngIf="lockError" class="text-danger mb-3">
        {{ lockError }}
      </div>

      <div class="d-flex justify-content-end">
        <button class="btn custom-button me-2" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn btn-danger"
          (click)="authenticateAndLockSite()"
          [disabled]="!lockEmail || !lockPassword || !lockReason"
        >
          Lock Site
        </button>
      </div>
    </div>
  </div>
</div>
